var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconParkSolidDownTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon-park-solid:down-two"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14_8779",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 28,
    height: 29
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 28.6677L28 16.0011L16 3.33439L16 11.3344L4 11.3344L4 20.6677L16 20.6677L16 28.6677Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14_8779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 31.9998L3.81596e-07 -0.000244141L32 -0.000243759L32 31.9998L0 31.9998Z",
    fill: "#858585"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkSolidDownTwo);
export default __webpack_public_path__ + "static/media/icon-park-solid_down-two.6c3c67bba36b16ca5a327d8ab3aec7f4.svg";
export { ForwardRef as ReactComponent };